import type { AccessRequest } from '../../schemas/access-gate.ts'

/** Origin of the run target a request was raised for; requests without `target_origin` fall back to the gate URL's. */
export function accessTargetOrigin(request: Pick<AccessRequest, 'url' | 'target_origin'>): string {
  return new URL(request.target_origin ?? request.url).origin
}

/** Request group: a waiting one-time code is private to its task; every other request groups by provider and target origin. */
export function accessRequestKey(request: Pick<AccessRequest, 'id' | 'provider' | 'url' | 'target_origin' | 'handoff'>): string {
  return request.provider === 'otp' && request.handoff === 'wait' ? request.id : `${request.provider}:${accessTargetOrigin(request)}`
}

export function distinctAccessRequests<T extends AccessRequest>(requests: T[]): T[] {
  const seen = new Set<string>()
  return requests.filter(request => {
    const key = accessRequestKey(request)
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}
